export default {
  'FourPChart.title': '4P анализ',
  'FourPChart.place': 'Место',
  'FourPChart.promotion': 'Промо',
  'FourPChart.product': 'Продукт',
  'FourPChart.price': 'Цена',
  'FourPChart.noData': 'Нет данных',
}
